import { render, staticRenderFns } from "./RevenueContainer.vue?vue&type=template&id=4b634a64&scoped=true&"
import script from "./RevenueContainer.vue?vue&type=script&lang=js&"
export * from "./RevenueContainer.vue?vue&type=script&lang=js&"
import style0 from "./RevenueContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RevenueContainer.vue?vue&type=style&index=1&id=4b634a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b634a64",
  null
  
)

export default component.exports